import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M10 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M7.252 23.516A8 8 0 0 0 10 24a8 8 0 0 0 2.749-.485Q11.735 21.997 9.999 22q-1.732.003-2.747 1.516M10 21.667c.368 0 .667-.597.667-1.334 0-.736-.299-1.333-.667-1.333s-.666.597-.666 1.333c0 .737.298 1.334.666 1.334m0-4.334c.736 0 1.333-.298 1.333-.666S10.736 16 10 16c-.737 0-1.334.299-1.334.667s.597.666 1.334.666m0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1.333 1h2.666v.334H8.666zm0 2.334h2.666V18H8.666z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M9.17 18.333h1.66c.298 0 .56.198.642.484l.528 1.85s-1.157-2-2-2c-.843-.001-2 2-2 2l.529-1.85a.67.67 0 0 1 .64-.484M9.17 15h1.66c.298 0 .56-.197.642-.483l.528-1.85s-1.157 1.999-2 2-2-2-2-2l.529 1.85a.67.67 0 0 0 .64.483",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M10.2 8.002v14.665h-.4V8.002a8 8 0 0 1 .4 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M9.333 11.86c.443-.085 1.976-2.14 1.976-2.351 0-.212-1.616 1.024-1.976 1.158s-.667.298-.667.666.224.613.667.528",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagNcl = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNcl_default = SvgFlagNcl;

export { FlagNcl_default as default };
